module.exports = __webpack_public_path__ + "static/media/zy.fe3c446d.png";